import React from 'react';
import {
    TabContent, TabPane, Nav,
    NavItem, NavLink, Row,
    Col
} from 'reactstrap';
import classnames from 'classnames';

import CurrentVersion from '../../../components/CurrentVersion/CurrentVersion';
import AlternativeProducts from '../../../components/AlternativeProducts/AlternativeProducts';
import Spinner from '../../../components/common/Spinner/Spinner';
import BetaBanner from '../../../images/BetaBanner.jpg';

export default class AssetDetail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: this.props.activeTab
        };
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
        if (tab === '1') {
            this.props.changePaginationState(false);
        } else if (tab === '2') {
            this.props.changePaginationState(true);
        }
    }

    render() {
        const { label, details, alternativeProducts, showAlternativeTab } = this.props;

        const alternativeProductsTab = (showAlternativeTab ? <NavItem>
                                        <NavLink
                                            id="tab-alternative-products"
                                            aria-selected="false"
                                            className={classnames({ active: this.state.activeTab === '2' })}
                                            onClick={() => { this.toggle('2'); }}
                                            role="tab"
                                            href="#"
                                            aria-controls="panel2">
                                            Alternative Products
                                        </NavLink>
                                    </NavItem> : null)
        return (
            <div>
                <Nav tabs role="tablist">
                    <NavItem>
                        <NavLink
                            id="tab-current-version"
                            aria-selected="true"
                            className={classnames({ active: this.state.activeTab === '1' })}
                            onClick={() => { this.toggle('1'); }}
                            role="tab"
                            href="#"
                            aria-controls="panel1">
                            Current Version
                        </NavLink>
                    </NavItem>
                    {alternativeProductsTab}
                </Nav>
                <TabContent className="mt-3" activeTab={this.state.activeTab}>
                    <TabPane id="panel1" tabId="1" aria-labelledby="tab-current-version" role="tabpanel">
                        <Row className="pr-5">
                           <Col md="8" sm="12" className="p-0">
                                <CurrentVersion category={label} details={details} />
                            </Col>
                            <Col md="4" className="pr-5 pb-5">
                                <img id="asset-image" alt="Flexera Technopedia Beta Advert" width="375" src={BetaBanner}/>
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane id="panel2" tabId="2" aria-labelledby="tab-alternative-products" role="tabpanel">
                        <Row className="min-height-div">
                            <Col sm="12" className="p-0">
                                {this.props.componentLoading ?
                                    <Spinner /> :
                                    <AlternativeProducts alternativeProducts={alternativeProducts} />
                                }
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/ViewAsset/AssetDetail/AssetDetail.js